import React from 'react'
import { ErrorWrapper, Input, Label, Rules, TabChanger } from '../../../styles/newStyles/Register.styled'
import Text from '../../../core/utils/Text'
import { useMainContext } from '../../../modules/Dashboard'
import MailIcon from '../../../components/icons/MailIcon'

const SigninPage = ({
    onInputValueChange,
    inputValues,
    validationStatus,
}) => {
    const { main: { lang } } = useMainContext()


    return (
        <>
            <div className='flex flex-col gap-2'>
                <Label htmlFor='email'>
                    <MailIcon size={16} color='#869BDD' />
                    <Text tid={'email-address'} className='text-inherit' />
                </Label>
                <Input
                    type='text'
                    placeholder={lang === 'fa' ? ' ایمیل خود را وارد کنید' : "Enter your email address"}
                    onChange={(e) => onInputValueChange(e, 'main')}
                    value={inputValues.mobileOrEmail}
                    autoFocus={true}
                    status={validationStatus}
                    id='email'
                />
                {validationStatus === 'error' && (
                    <ErrorWrapper>
                        <Text tid='wrong-format' className='text-sm' />
                    </ErrorWrapper>
                )}
            </div>

        </>
    )
}

export default SigninPage